import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const EditDocOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M14 7.71H6.9c-.44 0-.8.36-.8.8 0 .44.36.8.8.8H14c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8ZM11 11.21H6.9c-.44 0-.8.36-.8.8 0 .44.36.8.8.8H11c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8Z"
        fill={color}
      />
      <Path
        d="m20.66 11.73-1.19-1.19a1.09 1.09 0 0 0-.77-.32c-.28 0-.56.11-.78.32l-.89.89-6.24 6.24-.54 2.78c-.05.27.19.54.46.54h.07l2.73-.53 6.27-6.27h-.01l.89-.9c.43-.43.43-1.12 0-1.55v-.01Zm-7.83 7.43-.93.18.19-.98 4.95-4.95.77.77-4.98 4.98Zm5.87-7.41.76.76-.67.67-.76-.76.67-.67Z"
        fill={color}
      />
      <Path
        d="M9.6 18.65H6.58c-1.1 0-1.99-.89-1.99-1.99V7.35c0-1.1.89-1.99 1.99-1.99h7.33c1.1 0 1.99.89 1.99 1.99v4.11l1.6-1.7V7.35a3.6 3.6 0 0 0-3.59-3.59H6.59A3.6 3.6 0 0 0 3 7.35v9.31a3.6 3.6 0 0 0 3.59 3.59h2.66l.36-1.6H9.6Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default EditDocOutlined
